import { module } from 'modujs'

const INTERVAL = 2000 // ms

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onUpdateBind = this.onUpdate.bind(this)

        // UI
        this.$el = this.el
        this.$words = this.$('word')

        // Data
        this.currentIndex = 0

        // RAF
        this.requestAnimation = null
        this.raf = {
            interval: INTERVAL,
            deltaTime: 0,
            time: performance.now(),
            lt: performance.now(),
            elapsedInterval: 0,
            paused: false
        }
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.activeWord(this.currentIndex)
    }

    destroy() {
        super.destroy()
    }

    ///////////////
    // Methods
    ///////////////
    activeWord(index) {
        // Remove active state on old active word
        if (this.currentIndex > -1) {
            this.$words[this.currentIndex].classList.remove('is-active')
        }

        // Add active state on new current word
        this.$words[index].classList.add('is-active')
        this.currentIndex = index

        if (index == 3) {
            this.pause()
        }
    }

    inview(e) {
        if (e.way == 'enter') {
            this.play()
        } else {
            this.pause()
        }
    }

    onUpdate() {
        this.raf.time = performance.now()
        this.raf.deltaTime = this.raf.time - this.raf.lt
        this.raf.elapsedInterval += this.raf.deltaTime

        if (this.raf.elapsedInterval >= this.raf.interval) {
            this.raf.elapsedInterval = 0

            // Get new active word index
            const nextWordIndex = (this.currentIndex + 1) % this.$words.length
            this.activeWord(nextWordIndex)
        }

        this.raf.lt = this.raf.time

        this.requestAnimation = requestAnimationFrame(() => this.onUpdate())
    }

    play() {
        this.onUpdate()
    }

    pause() {
        cancelAnimationFrame(this.requestAnimation)

        // RAF
        this.raf = {
            interval: INTERVAL,
            deltaTime: 0,
            time: performance.now(),
            lt: performance.now(),
            elapsedInterval: 0,
            paused: false
        }
    }
}
